import GenerationAttributes from './components/GenerationAttributesList/GenerationAttributesList'
import GenerationAttributesGOCard from './components/GenerationAttributesGOCard/GenerationAttributesGOCard'

export { GenerationAttributes, GenerationAttributesGOCard }
